module.exports = __webpack_public_path__ + "static/media/037.b2a1547a.jpg";